import { render, staticRenderFns } from "./meuperfil.vue?vue&type=template&id=6e78b957"
import script from "./meuperfil.ts?vue&type=script&lang=js&external"
export * from "./meuperfil.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e78b957')) {
      api.createRecord('6e78b957', component.options)
    } else {
      api.reload('6e78b957', component.options)
    }
    module.hot.accept("./meuperfil.vue?vue&type=template&id=6e78b957", function () {
      api.rerender('6e78b957', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/meuperfil/meuperfil.vue"
export default component.exports